import { useCountdown } from "@/utils/useCountdown"

interface CounterProps {
    dataFim: string
    qtdeEstoque: number
    exibeQuantidadeEstoqueVitrine: boolean
}

export function Counter({ dataFim, qtdeEstoque, exibeQuantidadeEstoqueVitrine}: CounterProps) {
    const tempoRestante = useCountdown(dataFim)
    
    return (
        <div className="contador-ofertas">
            {dataFim && (
                <div className={`oferta-countdown ${!exibeQuantidadeEstoqueVitrine ? "full" : ""}`}>
                    <div data-fim={dataFim}>
                        <span className="text-contador">Acaba em</span>
                        <span className="alinha-contador">
                            {Number(tempoRestante.dias) > 0 && (
                                <span className="ctn dia">
                                    <span className="count">{tempoRestante.dias}d</span>
                                    <span className="text">:</span>
                                </span>
                            )}
                            <span className="ctn hora">
                                <span className="count">{tempoRestante.horas}h</span>
                                <span className="text">:</span>
                            </span>
                            <span className="ctn min">
                                <span className="count">{tempoRestante.minutos}m</span>
                                <span className="text">:</span>
                            </span>
                            <span className="ctn seg">
                                <span className="count">{tempoRestante.segundos}s</span>
                            </span>
                        </span>
                    </div>
                </div>
            )}

            {Boolean(exibeQuantidadeEstoqueVitrine) && (
                <div className={`oferta-restante ${!dataFim ? "full" : ""}`}>
                    <span className="quantidade-desc">
                        Quantidade <span>em oferta</span>
                    </span>
                    <span className="quantidade">{qtdeEstoque}</span>
                </div>
            )}
        </div>
    )
}